import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const ArrowLeft: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path clipRule="evenodd" d="M7.34838 16.276C7.83653 16.7642 8.62799 16.7642 9.11614 16.276C9.6043 15.7879 9.6043 14.9964 9.11614 14.5083L5.94668 11.3388L17.0711 11.3388C17.7614 11.3388 18.3211 10.7791 18.3211 10.0888C18.3211 9.39843 17.7614 8.83879 17.0711 8.83879L5.94677 8.83879L9.11614 5.66942C9.6043 5.18126 9.6043 4.38981 9.11614 3.90165C8.62799 3.41349 7.83653 3.4135 7.34837 3.90165L2.04507 9.20495C1.55692 9.69311 1.55692 10.4846 2.04508 10.9727L7.34838 16.276Z" fillRule="evenodd" /> 
  </CustomIcon>
);

export default ArrowLeft;